module.exports = __webpack_public_path__ + "images/file_icons_v2/3ds-7a7047d482b2b86ba362dbc04c2bfada.svg";